import {Injectable} from '@angular/core';
import {MotorQuoteDTO} from '../../models/MotorQuoteDTO.interfaces';
import {MotorStatus} from '../../enums/motorStatus.enum';
import { DateHelperService } from '../date-helper/date-helper.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private _canBuyFromMotor: boolean = true;
  private _canBuyFromAgency: boolean = true;
  private _isExternalInitUsed: boolean = false;

  constructor(
    private dateHelperService: DateHelperService
  ) {}

  canBuy() {
    return this._canBuyFromMotor && this._canBuyFromAgency;
  }

  setBuyPermissionFromMotor(motorData: MotorQuoteDTO) {
    //Date part
    
    const canBuyFromDate = !this.dateHelperService.checkDateFromObject(motorData);
    //Agreement part
    const hasAgreement = motorData.response.configuration.agreement?.value;
    //Status part
    const saveOnlyStatus = [MotorStatus.SAVE_NEW, MotorStatus.SAVE_ONLY, MotorStatus.QUOTE];
    if (saveOnlyStatus.indexOf(<MotorStatus>motorData.response.status) > -1 || hasAgreement) {
      this._canBuyFromMotor = false;
      return;
    }
    this._canBuyFromMotor = canBuyFromDate;
  }
  setBuyPermissionFromAgency(bool: boolean) {
    this._canBuyFromAgency = bool;
  }

  isExternalInitUsed() {
    const currentValue = this._isExternalInitUsed;
    if (!currentValue) this._isExternalInitUsed = true;
    return currentValue;
  }
}
